import React from 'react'
import {SvgIcon} from 'rambler-ui'

export default function AppsIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 15">
      <path d="M11 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 1.2c.993 0 1.8.807 1.8 1.8s-.807 1.8-1.8 1.8S9.2 4.993 9.2 4s.807-1.8 1.8-1.8M4 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 1.2c.993 0 1.8.807 1.8 1.8S4.993 5.8 4 5.8 2.2 4.993 2.2 4 3.007 2.2 4 2.2M4 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 1.2c.993 0 1.8.807 1.8 1.8s-.807 1.8-1.8 1.8-1.8-.807-1.8-1.8.807-1.8 1.8-1.8M13.5 10.4h-1.9V8.5a.5.5 0 0 0-.5-.5h-.2a.5.5 0 0 0-.5.5v1.9H8.5a.5.5 0 0 0-.5.5v.2a.5.5 0 0 0 .5.5h1.9v1.9a.5.5 0 0 0 .5.5h.2a.5.5 0 0 0 .5-.5v-1.9h1.9a.5.5 0 0 0 .5-.5v-.2a.5.5 0 0 0-.5-.5" />
    </SvgIcon>
  )
}
